import styled from "@emotion/styled";
import Link from "next/link";

const LeftBox = (props: { type: string }) => {
	const { type } = props;
	let signUpText = (
		<>
			<div>전문가님의 역량으로</div>
			<div>초기 스타트업을 돕고 </div>
			<div className="color">부수입을 창출하세요</div>
		</>
	);
	if (type === "client") {
		signUpText = (
			<>
				<div className="color">상위 10% 마케터를</div>
				<div>필요한 만큼 고용하세요</div>
			</>
		);
	}
	return (
		<LeftDescription className="pc">
			<Link href={type === "client" ? `/` : `/expert`}>
				<LogoItem
					className="btnc"
					src="/onepoint/assets/images/logo/h-logo.png"
					alt=""
				></LogoItem>
			</Link>
			<DescriptionBox>
				<Description>
					{signUpText}
					<div className="smallText">탑티어 마케터 파트타임 고용 서비스</div>
				</Description>
			</DescriptionBox>
		</LeftDescription>
	);
};

const LeftDescription = styled.div`
	flex: 1 0 40vw;
	position: relative;
	height: 100vh;
`;

const DescriptionBox = styled.div`
	position: absolute;
	left: 2.7vw;
	top: 40%;
`;

const Description = styled.div`
	font-style: normal;
	font-weight: 800;
	font-size: 2.5vw;
	line-height: 2.5vw;
	color: white;
	width: 35vw;

	* {
		word-break: break-all;
		white-space: pre-wrap;
	}

	> div {
		padding-top: 5px;
	}

	/* Gradient */

	> .color {
		background: var(--primary);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
		text-fill-color: transparent;
	}

	> .smallText {
		padding-top: 1vw;
		font-size: 1.3vw;
		font-weight: 400;
	}
`;

const LogoItem = styled.img`
	position: absolute;
	left: 0px;
	top: 0px;
	width: 150px;
	padding: 20px;
	padding-top: 35px;
	padding-bottom: 35px;

	@media screen and (min-width: 720px) {
		width: 200px;
		padding: 10px;
		padding-top: 25px;
		padding-bottom: 25px;
	}
`;

export default LeftBox;
